import { put } from 'redux-saga/effects';
import { authenticate } from 'auth/actions';
import { billing } from 'app/routes';

export function* billingNavigate() {
  yield put(authenticate(billing()));
}
